import { useRuta } from '../lib/ruta';

export function NoEncontrado() {
  const { ir } = useRuta();
  return (
    <div className="stack-lg">
      <header>
        <p className="eyebrow">Sin resultados</p>
        <h1 className="display">No encuentro esta página</h1>
        <p className="muted" style={{ margin: '6px 0 0' }}>Puede que el enlace haya cambiado o que el elemento ya no exista.</p>
      </header>
      <div><button className="btn primary" onClick={() => ir('/')}>Volver al inicio</button></div>
    </div>
  );
}
